import React from 'react';
import PropTypes from 'prop-types';

import FormatPrice from '@shared/containers/FormatPrice';

function OptionDescription({ amount, modifiesPrice }) {
  if (amount === 0) return null;

  return (
    <FormatPrice value={amount}>
      {formattedPrice => (
        <span className="option_text_description">
          {modifiesPrice ? `(${formattedPrice})` : `(+ ${formattedPrice})`}
        </span>
      )}
    </FormatPrice>
  );
}

OptionDescription.propTypes = {
  amount: PropTypes.number.isRequired,
  modifiesPrice: PropTypes.bool.isRequired,
};

export default OptionDescription;
